module.exports = __webpack_public_path__ + "static/media/kudu3.fcdd0f6f.mp4";